<form class="flex flex-col gap-2" [formGroup]="form">

  <p-autoComplete class="w-full"
    formControlName="incident"
    [suggestions]="incidents"
    [dropdown]="true"
    [forceSelection]="true"
    placeholder="Select an Incident"
    (completeMethod)="search($event)"
    [readonly]="true"
    [completeOnFocus]="true"
    optionLabel="summary"
    inputStyleClass="w-full"
    appendTo="body"

    >

  </p-autoComplete>


  <div class="flex gap1 justify-end">
    @if (showActionButtons && linkMode === 'link') {
      <button class="btn btn-primary" (click)="linkIncident()">Link</button>
    }
    @if (showActionButtons && linkMode === 'unlink') {
      <button class="btn btn-primary" (click)="unlinkIncident()">Unlink</button>
    }
  </div>
</form>
